import * as React from 'react'
import { Theme, useTheme } from '@mui/material/styles'
import { FC, useMemo } from 'react'

import { currencyString } from '@sales-center/common'
import { ENTITY_TYPES } from '@sales-center/common'
import { ILead } from '@user/store/lead/typings'
import { IOpportunity } from '@user/store/opportunity/typings'
import { LEAD_STATUSES } from '@user/components/Leads/LeadCard/typings'
import { OPPORTUNITY_STATUSES } from '@user/components/Opportunities/OpportunityCard/typings'
import { TotalValuePopover } from './TotalValuePopover'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const getStyles = (theme: Theme) => ({
  root: {
    marginBottom: theme.spacing(1.2),
  },

  label: {
    marginRight: theme.spacing(0.8),
    verticalAlign: 'middle',
  },

  total: {
    color: theme.palette.text.primary,
    fontSize: '21px',
    fontFamily: 'Source Sans Pro Bold',
    verticalAlign: 'middle',
  },
})

interface Props {
  detail: ILead | IOpportunity
  entityStatus: LEAD_STATUSES | OPPORTUNITY_STATUSES
  entityType: ENTITY_TYPES
}

function detailIsLead(detail: any): detail is ILead {
  if (detail.totalLeadValue !== undefined) return true
  return false
}

export const EntityValue: FC<Props> = (props) => {
  const { detail, entityStatus, entityType } = props
  const { initialValue, recurringValue } = detail

  const totalValue = useMemo(
    () => (detailIsLead(detail) ? detail.totalLeadValue : detail.totalValue),
    [detail],
  )
  const styles = getStyles(useTheme())
  return (
    <Box display="flex" alignItems="center" sx={styles.root}>
      <Box flexGrow={1}> </Box>
      <Box>
        <Typography whiteSpace="nowrap">
          <span style={styles.label}>Total Value</span>
        </Typography>
      </Box>
      <Box>
        <Typography>
          <span style={styles.total}>{`$${currencyString(totalValue)}`}</span>
        </Typography>
      </Box>
      <Box>
        <TotalValuePopover
          cardDetail={detail}
          entityType={entityType}
          entityStatus={entityStatus}
          initialValue={initialValue}
          recurringValue={recurringValue}
          totalValue={totalValue}
        />
      </Box>
    </Box>
  )
}

EntityValue.displayName = 'EntityValue'
